<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false" />
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-shield-alt text-primary"></i> Access</h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
          <label for="inputName" class="form-label">User List :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.userID" @change="loadUserAccess" >
            <option selected></option>
            <option v-for="(item, index) in UserList" :key="index" :value="item._id">
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 table-responsive mt-2">
          <div class="progress mb-0 progress-sm" v-if="progress != 0">
            <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100" :style="{ width: progress + '%' }" ></div>
          </div>
          <table class="table">
            <tbody>
              <tr v-for="menu in List" :key="menu._id">
                <th>{{ menu.name }}</th>
                <td> <input type="checkbox" class="mt-2 cursor-pointer" role="button" v-model="menu.visible" :true-value="true" :false-value="false" @change="updateAccess(menu, 'visible')" /> Read </td>
                <td> <input type="checkbox" class="mt-2 cursor-pointer" role="button" v-model="menu.create" :true-value="true" :false-value="false" @change="updateAccess(menu, 'create')" /> Create/Update </td>
                <td> <input type="checkbox" class="mt-2 cursor-pointer" role="button" v-model="menu.remove" :true-value="true" :false-value="false" @change="updateAccess(menu, 'remove')" /> Delete </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.name" @delRecord="delRecord" @closeModal="delObj.name = ''" />
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import { api } from "@/utils/helpers.js";
import { ref, onMounted } from "vue";
const Obj = ref({ userID: "" });
const msgObj = ref({ msg: "", role: "", show: false });
const delObj = ref({});
const List = ref([]);
const UserList = ref([]);
const progress = ref(0);
const loaduserlist = async () => {
  try {
    const response = await api.get(`/users/all`);
    UserList.value = response.data;
  } catch (error) {
    console.error("Error loading users:", error);
  }
};
const loadData = async () => {
  progress.value = 40;
  try {
    const response = await api.get("/menus/all");
    List.value = response.data .filter(m => !m.value.startsWith("/student/")) .map(m => ({
    ...m,
    visible: false,
    create: false,
    remove: false,
    accessId: null,
  }));
  } finally {
    progress.value = 0;
  }
};
const loadUserAccess = async () => {
  if (!Obj.value.userID) return;
  progress.value = 40;
  try {
    const response = await api.get("/menus/all");
   const allMenus = response.data .filter(m => !m.value.startsWith("/student/"));
    const accessRes = await api.get(`/menusaccess/user/${Obj.value.userID}`);
    const userAccess = accessRes.data;
    List.value = allMenus.map(menu => {
      const access = userAccess.find(a => a.menuID === menu._id);
      return {
        ...menu,
        visible: access ? access.visible : false,
        create: access ? access.create : false,
        remove: access ? access.remove : false,
        accessId: access ? access._id : null,
      };
    });
  } finally {
    progress.value = 0;
  }
};

const updateAccess = async (menu) => {
  const payload = {
    menuID: menu._id,
    userID: Obj.value.userID,
    visible: menu.visible,
    create: menu.create,
    remove: menu.remove,
  };
  progress.value = 40;
  try {
    if (menu.accessId) {
      await api.put(`/menusaccess/${menu.accessId}`, payload);
    } else {
      const res = await api.post(`/menusaccess/add`, payload);
      menu.accessId = res.data._id; 
    }
    msgObj.value = { msg: "Access updated successfully", role: "success", show: true };
  } catch (err) {
    console.error("Error updating access:", err);
  } finally { progress.value = 0; }
};
const delRecord = async () => {
  await api.delete(`/menus/${delObj.value._id}`).then(() => {
    delObj.value = {};
    loadData();
    msgObj.value = { msg: "Menus Deleted Successfully.", role: "danger", show: true };
  });
};
onMounted(() => {
  loadData();
  loaduserlist();
});
</script>
